import React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import previewTemplate1 from '../../../../assets/images/preview/1-23.png';
import previewTemplate2 from '../../../../assets/images/preview/2-23.png';
import previewTemplate3 from '../../../../assets/images/preview/3-23.png';
import previewTemplate4 from '../../../../assets/images/preview/4-23.png';
import previewTemplate5 from '../../../../assets/images/preview/5-23.png';
import previewTemplate6 from '../../../../assets/images/preview/6-23.png';
import previewTemplate7 from '../../../../assets/images/preview/7-23.png';
import previewTemplate8 from '../../../../assets/images/preview/8-23.png';

var itemData = [{
  id: 1,
  img: previewTemplate1,
  title: 'Preview 1'
}, {
  id: 2,
  img: previewTemplate2,
  title: 'Preview 2'
}, {
  id: 3,
  img: previewTemplate3,
  title: 'Preview 3'
}, {
  id: 4,
  img: previewTemplate4,
  title: 'Preview 4'
}, {
  id: 5,
  img: previewTemplate5,
  title: 'Preview 5'
}, {
  id: 6,
  img: previewTemplate6,
  title: 'Preview 6'
}, {
  id: 7,
  img: previewTemplate7,
  title: 'Preview 7'
}, {
  id: 8,
  img: previewTemplate8,
  title: 'Preview 8'
}];

var StandardImageList = function StandardImageList(_ref) {
  var currentIndex = _ref.currentIndex,
      handleImageClick = _ref.handleImageClick;


  return React.createElement(
    ImageList,
    { sx: {}, cols: 3 },
    itemData.map(function (item, index) {
      return React.createElement(
        ImageListItem,
        {
          key: item.img,
          onClick: function onClick() {
            return handleImageClick(index);
          },
          sx: {
            border: index == currentIndex ? '1px solid rgb(31, 107, 241)' : '1px solid #fff',
            borderRadius: index == currentIndex ? '5px' : '5px',
            padding: '5px'
          }
        },
        React.createElement('img', {
          style: { objectFit: 'contain', cursor: 'pointer' },
          src: item.img + '?w=164&h=164&fit=contain&auto=format',
          srcSet: '' + item.img,
          alt: item.title,
          loading: 'lazy',
          id: item.id
        })
      );
    })
  );
};

export default StandardImageList;


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/components/StandardImageList.js